import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComprovacaoUsuarioRoutingModule } from './comprovacao-usuario-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ComprovacaoUsuarioRoutingModule,
  ],
  exports: []
})
export class ComprovacaoUsuarioModule {
}
